import axios from "axios";
import { API_BASE } from "./api";

const empApi = axios.create({ baseURL: API_BASE });

empApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("emp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

empApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !window.location.pathname.startsWith("/portal/login")) {
      localStorage.removeItem("emp_token");
      window.location.href = "/portal/login";
    }
    return Promise.reject(err);
  }
);

export default empApi;
